const YearInMilliseconds = 31557600000;

const is17OrOver = (dateOfBirth: Date): boolean => {
	const currentDate = new Date();
	const ageInMilliseconds = currentDate.getTime() - dateOfBirth.getTime();
	const ageInYears = ageInMilliseconds / YearInMilliseconds;
	return ageInYears >= 17;
};

export default is17OrOver;
